const { getAttributes } = require('./actions/attributesActions');
const { ATTRIBUTES_ARCHIVE } = require('./action-types/attributes-types');
const { ATTRIBUTE_POST, ATTRIBUTE_UPDATE } = require('./action-types/focused-attribute-types');
const { snackbarShowMessage } = require('../redux/actions/snackbarActions');

const REFRESH_ACTION_TYPES = [
  ATTRIBUTE_POST.SUCCESS,
  ATTRIBUTE_UPDATE.SUCCESS,
  ATTRIBUTES_ARCHIVE.SUCCESS,
];

const attributesMiddleware = store => {
  const { dispatch, getState } = store;

  return next => action => {
    if (REFRESH_ACTION_TYPES.includes(action.type)) {
      const state = getState();
      const { selectedBrand } = state.UIReducer || {};
      dispatch(getAttributes({ brand: selectedBrand }));
    }

    if (action.type === ATTRIBUTE_POST.SUCCESS) {
      dispatch(snackbarShowMessage('Attribute successfully created'));
    }

    if ([ATTRIBUTE_UPDATE.SUCCESS, ATTRIBUTES_ARCHIVE.SUCCESS].includes(action.type)) {
      dispatch(snackbarShowMessage('Attribute successfully updated'));
    }

    next(action);
  }
}

export default attributesMiddleware;